import { windowWrapper } from '@clubmed/utils';
import * as legacyBookingUrlBuilder from './legacyBookingUrlBuilder';

function openLegacy(appContext, bookingParams, birthdayDateFormat) {
  windowWrapper.setLocation(
    legacyBookingUrlBuilder.buildUrl(bookingParams, appContext, birthdayDateFormat),
  );
}

export default {
  openLegacy,
};
